// @ts-strict-ignore
import { Pipe, PipeTransform } from '@angular/core';
import { MomentService } from '@fc-core';
import {
  DateTimeFormat,
  resolveDateTimeFormat,
} from '@fc-shared/utils/date-time-formats';

@Pipe({
  name: 'momentFormat',
})
export class MomentFormatPipe implements PipeTransform {
  constructor(private momentService: MomentService) {}

  transform(string: Date | string, format: DateTimeFormat): string {
    if (!string) return;
    return this.momentService
      .moment(string)
      .format(resolveDateTimeFormat(format));
  }
}
